<app-side-menu>
  <div class="deposit-refund-content">
    <div class="page-header mb-4">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar
        </button>
        <div>
          <h1 class="page-title mb-0">
            <i class="fas fa-undo-alt me-2"></i>
            {{ pageTitle }}
          </h1>
          <p class="page-subtitle mb-0">Gera conta a pagar pendente vinculada ao contrato (devolução da caução ao cliente).</p>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

    <div class="card mb-4" *ngIf="loadingContext">
      <div class="card-body text-center py-4">
        <span class="spinner-border text-primary me-2"></span>
        Carregando contrato...
      </div>
    </div>

    <div class="card mb-4" *ngIf="!loadingContext">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-file-contract me-2"></i>Contrato de origem</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label text-muted">Referência</label>
            <div class="fw-semibold">{{ contractLabel || '—' }}</div>
          </div>
          <div class="col-md-6">
            <label class="form-label text-muted">Número</label>
            <div class="fw-semibold">{{ contractNumber || '—' }}</div>
          </div>
          <div class="col-12" *ngIf="suggestedDepositAmount != null && suggestedDepositAmount > 0">
            <label class="form-label text-muted">Caução do contrato (sugestão)</label>
            <div class="d-flex align-items-center flex-wrap gap-2">
              <span class="fw-semibold text-primary">
                {{ suggestedDepositAmount | currency:'BRL':'symbol':'1.2-2' }}
              </span>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="applySuggestedAmount()">
                Usar este valor
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" [formGroup]="form" *ngIf="form">
      <div class="card-header">
        <h5 class="mb-0">
          <i class="fas fa-file-invoice-dollar me-2"></i>
          Conta a pagar — devolução de caução
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label for="documentNumber" class="form-label">Número do documento *</label>
            <input
              id="documentNumber"
              type="text"
              class="form-control"
              formControlName="documentNumber"
              [class.is-invalid]="isFieldInvalid('documentNumber')" />
            <div class="invalid-feedback" *ngIf="isFieldInvalid('documentNumber')">Obrigatório</div>
          </div>

          <div class="col-md-6">
            <label for="documentType" class="form-label">Tipo do documento</label>
            <input
              id="documentType"
              type="text"
              class="form-control fw-semibold"
              formControlName="documentType"
              readonly />
          </div>

          <div class="col-md-6">
            <label for="issueDate" class="form-label">Data de origem (hoje) *</label>
            <input
              id="issueDate"
              type="date"
              class="form-control"
              formControlName="issueDate"
              readonly
              [class.is-invalid]="isFieldInvalid('issueDate')" />
            <small class="text-muted">Sempre a data atual do registro</small>
          </div>

          <div class="col-md-6">
            <label for="dueDate" class="form-label">Data de vencimento *</label>
            <input
              id="dueDate"
              type="date"
              class="form-control"
              formControlName="dueDate"
              [class.is-invalid]="isFieldInvalid('dueDate')" />
            <small class="text-muted">Sugestão inicial: 90 dias após a data de origem (hoje). Você pode alterar.</small>
          </div>

          <div class="col-md-6">
            <label for="amount" class="form-label">Valor da devolução *</label>
            <div class="input-group">
              <span class="input-group-text">R$</span>
              <input
                id="amount"
                type="text"
                class="form-control"
                formControlName="amount"
                appCurrencyShiftMask
                inputmode="decimal"
                autocomplete="off"
                placeholder="0,00"
                [class.is-invalid]="isFieldInvalid('amount')" />
            </div>
            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('amount')">
              Informe um valor maior que zero
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Status</label>
            <input type="text" class="form-control" [value]="statusFixed" readonly />
          </div>

          <div class="col-12">
            <label for="description" class="form-label">Descrição{{ isB2b ? ' *' : '' }}</label>
            <textarea
              id="description"
              class="form-control"
              rows="2"
              formControlName="description"
              [class.is-invalid]="isFieldInvalid('description')"></textarea>
          </div>
        </div>

        <div class="d-flex flex-wrap gap-2 mt-4 pt-3 border-top">
          <button
            type="button"
            class="btn btn-success"
            (click)="submit()"
            [disabled]="isSubmitting || loadingContext">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
            <i class="fas fa-check me-1" *ngIf="!isSubmitting"></i>
            Registrar devolução
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="isSubmitting">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
